import axios from 'axios';
import { enqueueSnackbar } from 'notistack';

// const Deployed_Url = 'https://wapp-vemigo.azurewebsites.net/api';

// export const API_url = 'https://localhost:7247/api';
//export const API_url = 'https://wapp-vemigo.azurewebsites.net/api';
export const API_url = 'https://cnc-api.vemigo.in/api';

axios.defaults.baseURL = API_url;

declare module 'axios' {
  export interface AxiosRequestConfig {
    skipAuth?: boolean;
    _retry?: boolean;
  }
}

let isRefreshing = false;
let refreshSubscribers: ((token: string) => void)[] = [];

function onRefreshed(token: string) {
  refreshSubscribers.forEach((callback) => callback(token));
  refreshSubscribers = [];
}

axios.interceptors.request.use((config) => {
  if (!config.skipAuth) {
    const token = localStorage.getItem('token');
    if (token) config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    const status = error.response?.status;

    if (status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      const refreshToken = localStorage.getItem('refresh_token');
      if (!refreshToken) {
        localStorage.removeItem('token');
        localStorage.removeItem('refresh_token');
        window.location.href = '/login';
        return Promise.reject(error);
      }

      if (isRefreshing) {
        return new Promise((resolve) => {
          refreshSubscribers.push((newToken) => {
            originalRequest.headers['Authorization'] = `Bearer ${newToken}`;
            resolve(axios(originalRequest));
          });
        });
      }

      isRefreshing = true;

      try {
        const res = await axios.post(
          '/users/refresh',
          { refreshToken },
          { skipAuth: true }
        );

        const { access_token, refresh_token } = res.data.data;
        localStorage.setItem('token', access_token);
        localStorage.setItem('refresh_token', refresh_token);

        isRefreshing = false;
        onRefreshed(access_token);

        originalRequest.headers['Authorization'] = `Bearer ${access_token}`;
        return axios(originalRequest);
      } catch (err) {
        isRefreshing = false;
        localStorage.removeItem('token');
        localStorage.removeItem('refresh_token');
        window.location.href = '/login';
        return Promise.reject(err);
      }
    }

    if (!originalRequest._retry) {
      const message = error.response?.data?.message || 'An error occurred';
      enqueueSnackbar(message, { variant: 'error' });
    }

    return Promise.reject(error);
  }
);